interface NoDataAvailableComponentProps {
  message?: string;
}
export const NoDataAvailableComponent = ({
  message = 'No data available',
}: NoDataAvailableComponentProps) => {
  return <div>{message}</div>;
};
